<template>
  <div id="confirmationInput" class="menuSection">
    <h1 id="optionTitleConfirmation" class="optionTitle">
      {{ $t('productSelectHeadline') }}
    </h1>
    <hr />
    <div id="optionInputConfirmation">
      <div class="optionProduct">
        <h2>{{ $t('posterHeadline') }} - 49€</h2>
        <h3>{{ $t('posterSubheadline') }}</h3>
        <ul>
          <li>{{ $t('posterClaims.1') }}</li>
          <li>{{ $t('posterClaims.2') }}</li>
          <li>{{ deliveryTimes.poster.madeInFormatted }}</li>
        </ul>
        <p v-if="deliveryTimes">
          {{ deliveryTimes.poster.deliverTimeFormatted }}
        </p>

        <CheckoutButton
          id="buttonProduct"
          class="btnMenuPrimary"
          :showSpinner="isLeavingToCart"
          @click="addToCart(addToCartUrlPrintSuffix)"
        >
        </CheckoutButton>
      </div>
      <div class="optionProduct">
        <h2>{{ $t('forexHeadline') }} - 99€</h2>
        <h3 id="ourFavorite">
          {{ $t('ourFavorite') }}
        </h3>
        <h3>{{ $t('forexSubheadline') }}</h3>
        <ul>
          <li>{{ $t('forexClaims.1') }}</li>
          <li>{{ $t('forexClaims.2') }}</li>
          <li>{{ deliveryTimes["metal-print"].madeInFormatted }}</li>
        </ul>
        <p v-if="deliveryTimes">
          {{ deliveryTimes["metal-print"].deliverTimeFormatted }}
        </p>
        <CheckoutButton
          id="buttonProduct"
          class="btnMenuPrimary"
          :showSpinner="isLeavingToCart"
          @click="addToCart(addToCartUrlForexSuffix)"
        >
        </CheckoutButton>
      </div>
      <div class="optionProduct">
        <h2>{{ $t('pdfHeadline') }} - 29€</h2>
        <h3>{{ $t('pdfSubheadline') }}</h3>
        <ul>
          <li>{{ $t('pdfClaims.1') }}</li>
          <li>{{ $t('pdfClaims.2') }}</li>
        </ul>
        <CheckoutButton
          id="buttonProduct"
          class="btnMenuPrimary"
          :showSpinner="isLeavingToCart"
          @click="addToCart(addToCartUrlDigitalSuffix)"
        >
        </CheckoutButton>
      </div>
    </div>
  </div>
</template>

<script>
import { cartUrl } from '../../util/endpointConfig'
import { track } from '../../util/tracker'
import { store } from '../../store/store'
import CheckoutButton from './CheckoutButton'

export default {
  name: 'ConfirmationInput',
  props: {
    deliveryTimes: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    addToCartUrlPrintSuffix: function() {
      return '&lineItemProperties[delivery]=poster'
    },
    addToCartUrlForexSuffix: function() {
      return '&lineItemProperties[delivery]=metal-print'
    },
    addToCartUrlDigitalSuffix: function() {
      return '&lineItemProperties[delivery]=pdf'
    },
    addToCartBaseURL: function() {
      return (
        cartUrl +
        `?productType=soundwave&productId=${store.state.posterId}&replaceId=${store.state.initialPosterId}`
      )
    },
    isLeavingToCart: function() {
      return store.state.isLeavingToCart
    },
  },
  mounted: function() {
    track('visitedConfirmationScreen')
  },
  methods: {
    addToCart: async function(addToCartUrlSuffix) {
      await store.dispatch('prepareAddToCart')
      if (!store.state.error && store.state.posterId && store.state.smosterId) {
        window.location.assign(`${this.addToCartBaseURL}${addToCartUrlSuffix}`)
      }
    },
  },
  components: {
    CheckoutButton,
  },
}
</script>
<style scoped lang="scss">
#optionTitleConfirmation {
  text-align: center;
}

#confirmationInput {
  hr {
    margin: 0 0 20px 0;
  }
}

.optionProduct {
  margin-bottom: 2.3em;

  p {
    text-align: center;
    color: darkgreen;
    font-weight: 900;
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
  h2,
  h3 {
    text-align: center;
  }
  h2 {
    margin: 5px 40px 0px 40px;
  }
  h3 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  #ourFavorite {
    margin: 10px 0 -10px 0;
    a {
      color: #0000ee;
      font-size: 17px;
      letter-spacing: 1px;
    }
    &::first-letter {
      color: red;
      font-size: 1.2em;
    }
  }
  .btnMenuPrimary {
    width: 100%;
  }
}

ul {
  list-style-type: square;
  padding: 0;
  margin-left: 1em;
}

li {
  display: list-item;
  color: #707070;
  margin-bottom: 0.4em;
}
</style>
